module.exports = __webpack_public_path__ + "img/Classic.69cdcff9.jpg";